/* Ziggy Cuts — global.js
   Scroll reveals + mobile nav. No dependencies. */

(function () {
  'use strict';

  /* ---------- Scroll reveal ---------- */

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var io = null;

  if (!reduced && 'IntersectionObserver' in window) {
    io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.1 }
    );
  }

  function watchReveals(root) {
    (root.querySelectorAll ? root.querySelectorAll('.reveal') : []).forEach(function (el) {
      if (io) io.observe(el);
      else el.classList.add('is-visible');
    });
  }

  watchReveals(document);

  /* Re-scan when sections are re-rendered (theme editor, hot reload) */
  new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) {
          if (node.classList && node.classList.contains('reveal')) watchReveals({ querySelectorAll: function () { return [node]; } });
          watchReveals(node);
        }
      });
    });
  }).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', function (e) { watchReveals(e.target); });

  /* ---------- Mobile menu ---------- */

  var burger = document.querySelector('[data-menu-toggle]');
  var menu = document.querySelector('[data-mobile-menu]');

  if (burger && menu) {
    function setMenu(open) {
      menu.setAttribute('data-open', String(open));
      burger.setAttribute('aria-expanded', String(open));
      document.body.setAttribute('data-menu-open', String(open));
    }

    burger.addEventListener('click', function () {
      setMenu(menu.getAttribute('data-open') !== 'true');
    });

    // Close via the X button, any nav link, or Escape
    menu.querySelectorAll('[data-menu-close], a').forEach(function (el) {
      el.addEventListener('click', function () { setMenu(false); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && menu.getAttribute('data-open') === 'true') setMenu(false);
    });
  }

  /* ---------- Marquee: duplicate content, JS-driven scroll ----------
     JS drives the translate so hovering can ease the speed down to 50%
     (measured on the original site) without the jump that changing a
     CSS animation-duration mid-flight would cause. */

  document.querySelectorAll('.marquee__track[data-duplicate]').forEach(function (track) {
    var half = track.children.length;
    track.innerHTML += track.innerHTML;
    Array.prototype.slice.call(track.children, half).forEach(function (clone) {
      clone.setAttribute('aria-hidden', 'true');
      (clone.matches('a') ? [clone] : Array.prototype.slice.call(clone.querySelectorAll('a'))).forEach(function (a) {
        a.setAttribute('tabindex', '-1');
      });
    });
  });

  if (!reduced) {
    document.querySelectorAll('.marquee').forEach(function (marquee) {
      var track = marquee.querySelector('.marquee__track');
      if (!track) return;
      var duration = parseFloat(getComputedStyle(track).getPropertyValue('--marquee-duration')) || 40;
      var reverse = marquee.classList.contains('marquee--reverse');
      track.style.animation = 'none';

      var pos = 0;
      var factor = 1;
      var target = 1;
      var half = 0;
      var last = null;

      var measure = function () { half = track.scrollWidth / 2; };
      measure();
      window.addEventListener('resize', measure);

      marquee.addEventListener('mouseenter', function () { target = 0.5; });
      marquee.addEventListener('mouseleave', function () { target = 1; });

      var step = function (now) {
        if (last !== null && half > 0) {
          var dt = Math.min((now - last) / 1000, 0.1);
          factor += (target - factor) * 0.08;
          /* normalize: duration = seconds per 2400px, so equal duration
             settings scroll at equal px/s regardless of track length */
          var v = (2400 / duration) * factor * dt;
          pos += reverse ? v : -v;
          if (pos <= -half) pos += half;
          if (pos > 0) pos -= half;
          track.style.transform = 'translateX(' + pos.toFixed(2) + 'px)';
        }
        last = now;
        requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    });
  }

  /* Unison caption + set cycling now live in the shop-in-unison section. */

  /* ---------- Scroll-driven page scheme (dark -> #999 -> dark) ----------
     Gray turns on as the unison section enters and off as the reviews
     section takes over (matches original behavior). */

  var unisonSection = document.querySelector('.unison');
  if (unisonSection && 'IntersectionObserver' in window) {
    var zoneIO = new IntersectionObserver(
      function (entries) {
        document.body.classList.toggle('zone-light', entries[0].isIntersecting);
      },
      { rootMargin: '-15% 0px -15% 0px' }
    );
    zoneIO.observe(unisonSection);
  }

  /* ---------- Barbering photo parallax ----------
     The photo is ~146% of its frame; it drifts through the frame as the
     section crosses the viewport (matches original scroll depth). */

  var parallaxFrame = document.querySelector('[data-parallax-frame]');
  var parallaxImg = parallaxFrame && parallaxFrame.querySelector('img, video');
  if (parallaxFrame && parallaxImg && !reduced) {
    var pTicking = false;
    var parallax = function () {
      if (pTicking) return;
      pTicking = true;
      requestAnimationFrame(function () {
        pTicking = false;
        var r = parallaxFrame.getBoundingClientRect();
        var travel = parallaxImg.offsetHeight - r.height;
        if (travel <= 0) return;
        var p = (window.innerHeight - r.top) / (window.innerHeight + r.height);
        p = Math.min(Math.max(p, 0), 1);
        parallaxImg.style.transform = 'translateY(' + (-travel * p).toFixed(1) + 'px)';
      });
    };
    window.addEventListener('scroll', parallax, { passive: true });
    parallax();
  }

  /* ---------- Hero logo: dissolve into the intro on scroll ---------- */

  var heroLogo = document.querySelector('.hero__logo');
  var hero = document.querySelector('.hero');
  var headerLogo = document.querySelector('.site-header__logo');
  if (heroLogo && hero && !reduced) {
    /* header logo stays hidden until the hero logo has dissolved */
    if (headerLogo) document.body.setAttribute('data-hero-logo', 'visible');
    var heroTicking = false;
    var heroDissolve = function () {
      if (heroTicking) return;
      heroTicking = true;
      requestAnimationFrame(function () {
        heroTicking = false;
        var range = hero.offsetHeight * 0.55;
        var p = Math.min(Math.max(window.scrollY / range, 0), 1);
        if (p > 0) heroLogo.style.transition = 'none'; /* hand off from entrance */
        heroLogo.style.opacity = String(1 - p);
        heroLogo.style.transform = 'translateY(' + (-48 * p).toFixed(1) + 'px) scale(' + (1 - 0.18 * p).toFixed(3) + ')';
        if (headerLogo) document.body.setAttribute('data-hero-logo', p >= 1 ? 'gone' : 'visible');
      });
    };
    window.addEventListener('scroll', heroDissolve, { passive: true });
    heroDissolve();
  }

  /* ---------- Lenis smooth scroll (premium inertia feel) ---------- */

  if (!reduced && window.Lenis && !(window.Shopify && window.Shopify.designMode)) {
    new window.Lenis({ autoRaf: true });
  }
})();
